import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/site";

const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.08 } }),
};

export const Services = () => {
  const active = SERVICES[0];
  const soon = SERVICES.slice(1);

  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <span className="text-xs tracking-[0.3em] uppercase text-gold font-bold font-mono-x">What We Do</span>
            <h2 className="font-heading font-bold uppercase tracking-tight text-4xl sm:text-5xl mt-4 text-white">
              Our <span className="gold-gradient-text">Services</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md text-base">
            Starting with what we do best — and expanding the garage soon. Every service is
            performed in-house with premium materials.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-5">
          {/* Active feature card */}
          <motion.div
            data-testid="service-card-window-tinting"
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            custom={0}
            className="col-span-12 lg:col-span-7 group relative overflow-hidden bg-[#0A0A0A] border border-white/10 min-h-[420px] hover:border-[#D4AF37]/50 transition-all duration-500"
          >
            <img src={active.image} alt={active.name} className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
            <div className="relative z-10 h-full flex flex-col justify-end p-8 md:p-10">
              <span className="self-start text-[10px] font-mono-x tracking-[0.2em] uppercase border border-[#D4AF37]/50 bg-[#D4AF37]/10 text-gold px-3 py-1 mb-5">Now Booking</span>
              <h3 className="font-heading font-bold text-3xl md:text-4xl uppercase text-white">{active.name}</h3>
              <p className="text-neutral-300 mt-4 max-w-md">{active.blurb}</p>
              <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2">
                {active.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-neutral-300">
                    <Check size={16} className="text-gold" /> {p}
                  </li>
                ))}
              </ul>
              <button
                data-testid="service-book-tinting"
                onClick={() => go("#booking")}
                className="self-start mt-8 inline-flex items-center gap-2 bg-gold text-black font-bold uppercase tracking-widest text-xs px-7 py-3 hover:bg-[#C5A028] transition-colors"
              >
                Book Window Tint <ArrowUpRight size={16} />
              </button>
            </div>
          </motion.div>

          {/* Coming soon cards */}
          <div className="col-span-12 lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
            {soon.map((s, i) => (
              <motion.div
                key={s.name}
                data-testid={`service-card-${s.name.toLowerCase().replace(/[^a-z]+/g, "-").replace(/(^-|-$)/g, "")}`}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                custom={i + 1}
                className="group relative overflow-hidden bg-[#0A0A0A] border border-white/10 p-6 min-h-[125px] flex flex-col justify-between hover:border-white/20 transition-all duration-500"
              >
                <img src={s.image} alt={s.name} className="absolute inset-0 w-full h-full object-cover opacity-15 group-hover:opacity-25 transition-opacity duration-500" />
                <div className="relative z-10 flex items-start justify-between">
                  <h3 className="font-heading font-bold text-xl uppercase text-white pr-2">{s.name}</h3>
                  <span className="shrink-0 text-[10px] font-mono-x tracking-[0.15em] uppercase border border-[#CC1100]/50 bg-[#CC1100]/10 text-[#FF5544] px-2.5 py-1">Soon</span>
                </div>
                <p className="relative z-10 text-sm text-neutral-400 mt-3">{s.blurb}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
